class ArrayHelpers {
  static splitArray<T>(array: T[], size: number) {
    return array.reduce((acc, _, index) => {
      if (index % size === 0) {
        acc.push(array.slice(index, index + size));
      }
      return acc;
    }, [] as T[][]);
  }
  static removeDuplicates<T>(array: T[]): T[] {
    return Array.from(new Set(array));
  }

  /**
   * Swaps each selected item for the offered one with the same key, dropping any no longer offered.
   * Keeps a selection pointing at the fresh objects a refetch brings, where comparing by reference would drop them.
   * Returns the same array when nothing changed, so a state update with it skips the render.
   */
  static reconcile<T>(selected: T[], offered: T[], getKey: (item: T) => string) {
    const offeredByKey = new Map(offered.map((item) => [getKey(item), item]));
    const reconciled = selected.flatMap((item) => offeredByKey.get(getKey(item)) ?? []);
    const unchanged = reconciled.length === selected.length && reconciled.every((item, i) => item === selected[i]);

    return unchanged ? selected : reconciled;
  }
}

export default ArrayHelpers;
